import api from "@/api";

const state = {
    list: [],
};

const getters = {
    list(state) {
        return state.list.map(u => {
            return { ...u, name: u.firstname + " " + u.lastname };
        });
    },
};

const actions = {
    findByName(
        { commit },
        { query, sort = "default", offset = 0, includeDeactivatedUsers = false },
    ) {
        if (!query) {
            commit("updateList", { list: [] });
            return;
        }

        let userFilter;

        if (sort === "reportsSearch") {
            userFilter = { include: { admin: [{ _id: "reportsSearch" }] } };
        } else if (sort === "indirectReportsSearch") {
            userFilter = { include: { admin: [{ _id: "indirectReportsSearch" }] } };
        } else {
            userFilter = { include: { fullname: query } };
        }

        if (includeDeactivatedUsers) {
            userFilter.include.status = ["active", "invited", "created", "deactivated"];
        }

        return api.post(`/api/users/list`, { userFilter, offset }).then(res => {
            const list = res.data || [];
            commit("updateList", { list });
        });
    },
    findByEmailBatch(_ignoreMe, args) {
        return api.post(`/api/users/email/batch`, args).then(res => res.data.users);
    },
    reset({ commit }) {
        commit("updateList", { list: [] });
    },
};

const mutations = {
    updateList(state, { list }) {
        state.list = [...list];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
